export default __webpack_public_path__ + "static/media/mini-planets.e50c448a.mp4";